export enum LeadHistoryEventType {
    Comment = 0,
    Created = 1,
    ColumnChanged = 2,
    StatusChanged = 3,

    // O 4 (webhook da Meta) não existe no RIS: os números divergem para não reinterpretar histórico.
    MessageReceived = 4,

    ScheduleCreated = 5,
    ScheduleDone = 6,
    ScheduleReopened = 7,
    ScheduleRescheduled = 8,
    ScheduleNotReached = 9,
    AssignedChanged = 10,
    AutomationApplied = 12,

    // E-mail com o lead que a equipe mandou com o endereço do CRM em cópia.
    Email = 13,

    // O 11 foi o das tags na primeira versão; o histórico antigo ainda guarda linhas com ele.
    TagsChanged = 14,

    CustomFieldsChanged = 15,
}
